exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group .btn__content{min-width:130px!important}.tab-btn-container{display:flex;flex-direction:row}[dir] .tab-btn-container{background:#eee;border-radius:8px}.import-export-btn{width:50%}[dir] .import-export-btn{text-align:center;padding:6px}.tab-btn{height:32px;display:flex;justify-content:center;align-items:center;user-select:none;transition:all .3s}[dir] .tab-btn{border-radius:8px;cursor:pointer}.active-tab-btn{color:#fff}[dir] .active-tab-btn{background-color:#006b8d}.response-div{font-size:20px;font-weight:500;color:#fff;display:inline}[dir] .response-div{background-color:#006b8d;padding:6px 8px;border-radius:4px}.inch-div{font-style:italic;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ff78b390","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/checkRate.vue
// module id = 1017
// module chunks = 0